/**
 * 文件说明:
 *
 * GlobalHeader component
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo, useMemo} from 'react'
import {Layout} from 'antd'
import {Link, NavLink} from 'umi'
import logo from './images/logo.png'
import styles from './index.less'

const {Header} = Layout

const GlobalHeader = memo((props) => {
    const {menus = [], RightContent, companyName = '', homePageUrl = '/'} = props

    const Menus = useMemo(
        () =>
            menus.map((item) => {
                if (item.isExternal) {
                    return (
                        <a
                            key={`barNav-${item.id}`}
                            className={styles.navLink}
                            href={item.externalUrl}
                            target={item.target}
                            rel="noopener noreferrer"
                        >
                            {item.name}
                        </a>
                    )
                }

                return (
                    <NavLink
                        {...item}
                        className={styles.navLink}
                        activeClassName={styles.navLinkActive}
                    >
                        {item.name}
                    </NavLink>
                )
            }),
        [menus],
    )

    return (
        <Header className={styles.main}>
            <Link to={homePageUrl} title="前往首页" className={styles.logo}>
                <img src={logo} alt="logo" />
                <div className={styles.companyName}>
                    <span>{companyName}</span>
                </div>
            </Link>
            <div className={styles.menus}>{Menus}</div>
            <div className={styles.right}>{RightContent}</div>
        </Header>
    )
})

export default GlobalHeader
